import { useCity } from "@/contexts/CityContext";
import { isCurrentAlert, usePublicAlerts } from "@/lib/public-alerts";
import { PULSE_PATH } from "@/lib/pulse-trace";

/**
 * The moving brand mark: a thin monitor trace along the bottom of the
 * header. A bright segment sweeps across every few seconds; it turns coral
 * only while an Urgent public-health notice is current. Static twin:
 * PULSE_TRACE in scripts/prerender-markup.mjs.
 */
export function PulseTrace() {
  const { city } = useCity();
  // Same query key as Home, so the request is shared.
  const { data } = usePublicAlerts(city.slug, 10, { category: "public_health" });
  const windowDays = data?.meta.currentWindowDays;
  const urgent = (data?.items ?? []).some((alert) => alert.level === 4 && isCurrentAlert(alert, windowDays));
  return (
    <div className="ds-pulse" data-tone={urgent ? "urgent" : "calm"} aria-hidden="true">
      <svg viewBox="0 0 1440 16" preserveAspectRatio="none" focusable="false">
        <path className="ds-pulse__base" d={PULSE_PATH} />
        <path className="ds-pulse__sweep" d={PULSE_PATH} pathLength={1000} />
      </svg>
    </div>
  );
}
